<template>
  <div class="mobile">
    <div class="fullbox">
      <div class="user">
        <div class="left">
          <img :src="userinfo.icon" alt="" />
        </div>
        <div class="right">
          <div class="name">Hi,{{ userinfo.nickname }}</div>
          <div class="department">{{ userinfo.department }}</div>
        </div>
      </div>
      <div class="content">
        <div class="evaluation">
          <div class="title">员工考评</div>
          <div class="imgList">
            <img
              src="@/assets/evaluation/icon4.png"
              alt=""
              @click="toUrl('/evaluation/object')"
            />
            <!-- <img
              src="@/assets/evaluation/icon2.png"
              alt=""
              @click="toUrl('/evaluation/myEvaluation')"
            /> -->
          </div>
        </div>
        <div class="back" v-if="redirect && backendFlag">
          <div class="title">管理后台</div>
          <div class="imgList">
            <img
              src="@/assets/evaluation/icon3.png"
              alt=""
              @click="toUrl('/evaluation/backend/evaluationManagement')"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { redirectRoute } from "@/utils/tools";
import { getToken } from "@/utils/cookie";
export default {
  components: {},
  data() {
    return {
      userinfo: {},
      redirect: false,
      backendFlag: false,
    };
  },
  mounted() {
    const loginEvaluation = JSON.parse(
      sessionStorage.getItem("loginEvaluation")
    );
    if (loginEvaluation) {
      this.userinfo = loginEvaluation;
    } else {
      this.userinfo = JSON.parse(localStorage.getItem("store")).userInfo;
      this.getRedirect();
      let token = getToken();
      if (token) {
        if (
          token == "10005038" ||
          token == "10007372" ||
          token == "10008797" ||
          token == "10008704" ||
          token == "10007380" ||
          token == "10002705" ||
          token == "10006489" || 
          token == "10003302"
        ) {
          this.backendFlag = true;
        }
      } else {
        this.$bus.$on("processToken", (res) => {
          if (
            res == "10005038" ||
            res == "10007372" ||
            res == "10008797" ||
            res == "10008704" ||
            res == "10007380" ||
            res == "10002705" ||
            res == "10006489" || 
            res == "10003302"
          ) {
            this.backendFlag = true;
          }
        });
      }
    }
  },
  methods: {
    //控制后台
    getRedirect() {
      this.redirect = redirectRoute();
    },
    //跳转
    toUrl(path) {
      this.$router.push(path);
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .fullbox {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .fullbox {
    width: 306px * $zoom;
    ::v-deep {
      .van-dropdown-item {
        width: 306px * $zoom !important;
        margin: auto;
      }
    }
  }
}
.mobile {
  width: 100%;
  display: flex;
  justify-content: center;
}
.fullbox {
  font-size: 14px * $zoom;
  position: relative;
  height: 100vh;
  overflow: hidden;
  padding-top: 40px;
  background: url("~@/assets/evaluation/bg.png") no-repeat;
  background-size: 100% 100%;
  .user {
    display: flex;
    align-items: center;
    padding: 12% 0 0 50px;
    .left {
      img {
        width: 85px;
        height: 85px;
        border-radius: 50%;
      }
    }
    .right {
      margin-left: 30px;
      .name {
        font-size: 32px;
      }
      .department {
        font-size: 28px;
        margin-top: 10px;
        color: #6c727f;
      }
    }
  }
  .content {
    margin-top: 60px;
    padding-left: 40px;
    .back {
      margin-top: 50px;
    }
    .title {
      color: #080a12;
      font-size: 32px;
      font-weight: bold;
    }
    .imgList {
      display: flex;
      // flex-wrap: wrap;
      margin-top: 20px;
      img {
        width: 46%;
      }
      img:nth-child(2) {
        margin-left: 3%;
      }
    }
  }
}
</style>
